const GA_ID = (process.env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();
export const GA_ENABLED = !!GA_ID;

let initialized = false;

// Injects the official gtag.js script once and boots GA4.
export function initGA() {
  if (initialized || !GA_ID || typeof window === "undefined") return;
  initialized = true;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  s.setAttribute("data-ga4", GA_ID);
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  // We fire page_view manually on every route change (SPA), so disable auto.
  gtag("config", GA_ID, { send_page_view: false });
}

// Fires a GA4 page_view for the given SPA path.
export function trackPageView(path) {
  if (!GA_ID || typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
